import React from 'react'
import PropTypes from 'prop-types'
import { ACCESSIBILITY_CLASSES, TAB_INDEXES, triggerClickOnEnter } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const ShareButton = ({themeColorHex, onClick}) => (
  <div
    className={`share-button ${ACCESSIBILITY_CLASSES.main}`}
    onClick={onClick}
    onKeyUp={triggerClickOnEnter}
    style={{
      borderColor: themeColorHex,
      backgroundColor: themeColorHex,
    }}
    tabIndex={TAB_INDEXES.ShareButton}
    role="button"
  >
    <span className="icon-share"/>
  </div>
)


ShareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default ShareButton
